export default __webpack_public_path__ + "static/media/facil1.0c54c382.png";